<template>
  <div class="tweet">
    <div class="tweet-badge">{{ number }}</div>
    <div class="tweet-profil">
      <img
        v-if="infos.profilImage"
        :src="require('@/assets/tweet/' + infos.profilImage)"
        alt="Photo de profil"
      />
      <div class="tweet-profil-pseudo name-twitto">
        <h3 v-if="infos.profilName">{{ infos.profilName }}</h3>
        <p v-if="infos.profilPseudo">{{ infos.profilPseudo }}</p>
      </div>
    </div>

    <div class="tweet-content">
      <p v-if="infos.tweetText" v-html="infos.tweetText"></p>
      <img
        v-if="infos.tweetImage"
        :src="require('@/assets/tweet/' + infos.tweetImage)"
        alt="Tweet image"
        :class="{'content-share': number != 2}"
      />
    </div>
    <div class="tweet-informations">
      <ul v-if="infos.tweetDate || infos.tweetHour || infos.tweetFrom">
        <li>{{ infos.tweetDate }}</li>
        <li>{{ infos.tweetHour }}</li>
        <li>{{ infos.tweetFrom }}</li>
      </ul>
    </div>

    <hr />
    <div class="tweet-numbers reactions">
      <ul v-if="infos.retweetNumber || infos.quotedNumber || infos.likesNumber">
        <li v-if="infos.retweetNumber" >
          <span class="text-bold">{{ infos.retweetNumber }}</span> Retweets
        </li>
        <li v-if="infos.quotedNumber" >
          <span class="text-bold">{{ infos.quotedNumber }}</span> Tweets ciblés
        </li>
        <li v-if="infos.likesNumber">
          <span class="text-bold">{{ infos.likesNumber }}</span> j'aime
        </li>
      </ul>
      <p v-else class="see-activity">
        <img
          :src="require('@/assets/tweet/activity.svg')"
          width='10'
          alt="Tweet image"
        />Voir l'activité sur Twitter
      </p>
    </div>

    <hr />
    <TweetActions />

     <div v-if="infos.comments" class="tweet-content comment">
      <img
        :src="require('@/assets/tweet/' + infos.comments)"
        alt="Tweet image"
      />
    </div>
  </div>
</template>

<script>
import TweetActions from "./TweetActions.vue";
export default {
  name: "Tweet",
  components: {
    TweetActions,
  },
  data: () => ({}),
  props: {
    infos: {},
    number: Number
  },
};
</script>

<style lang="scss">
.active {
  transition: 0.2s;
  background: #86e2ce;
}
.text-blue {
  color: rgb(0, 204, 255);
}
.active-content-share {
    border: 8px solid #86e2ce;
  box-sizing: border-box;
}
.tweet {
  border: 1px solid black;
  box-shadow: 6px 10px 10px rgb(200, 200, 200);
  text-align: left;
  padding: 0.5rem;
  display: inline-block;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  position: relative;

  &-badge {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 40px;
    top: 0;
    transform: translate(0, -50%);
    background-color: #000;
    color: #FFF;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    font-weight: bold;
  }

  &-profil {
    display: flex;
    font-size: 0.5rem;
    img {
      border-radius: 50px;
      width: 30px;
      height: 30px;
      object-fit: cover;
    }
    &-pseudo {
      display: flex;
      flex-direction: column;
      margin-top:.4rem;
      h3 {
        margin: 0 0.5rem;
      }
      p {
        opacity: 0.6;
        margin: 0 0.8rem;
      }
    }
  }
  &-content {
    font-size: 0.7rem;
    &.comment {
      margin-top: .5rem;
    }
    p {
      .hashtag {
        color: rgb(0, 204, 255);
      }
    }
    img {
      border-radius: 20px;
      width: 100%;
    }
  }
  hr {
    opacity: 0.2;
  }
  &-informations,
  &-numbers {
    ul {
      list-style: none;
      display: flex;
      font-size: 0.5rem;
      padding: 0;
      opacity: 0.8;
      li {
        margin-right: 0.5rem;
      }
    }
    .see-activity {
      font-size: 0.5rem;
      img {
        margin-right: .3rem;
      }
    }
  }
}
</style>
